
export function bnf (): string {
    return [
        // TOP LEVEL DEFINITIONS
        'syntax          ::= command | expression',
        'expression      ::= pipes | parenthesis | literal | token',
        'leaf            ::= parenthesis | token',

        // PARENS
        'parenthesis     ::= "(" syntax ")"',

        // LITERALS
        'literal         ::= "```" literaltoken "```" ',

        // COMMANDS
        'command         ::= value | data | output | time | env | code | join',

        'value           ::= "$VALUE#" arg',
        'data            ::= "$DATA#" arg',
        'output          ::= "$OUTPUT#" arg "#" arg',
        'time            ::= "$$TIME#" arg "#" arg',
        'env             ::= "$ENV#" arg',
        'code            ::= "$CODE#" args',
        'join            ::= "$JOIN#" args | "$JOIN##" args',

        'args            ::= arg ("#" arg)*',
        'arg             ::= expression',

        // PIPES
        'pipes           ::= pipe ("|" pipe)+',
        'pipe            ::= function | leaf',

        // FUNCTIONS
        'function        ::= "[" leaf "=>" (leaf "=" leaf | leaf) "]"',

        // CHARS
        'ESCAPE          ::= #x5C',
        'HEXDIG          ::= [a-fA-F0-9]',

        `token           ::= (CHAR)+ `,
        `literaltoken    ::= (ANYCHAR)+ `,

        'CHAR            ::= UNESCAPED | ESCAPE ESCAPABLE | ESCAPE BACKTICK',
        'ANYCHAR         ::= ESCAPE BACKTICK | UNESCAPED | ESCAPABLE',

        'BACKTICK        ::= "`"', // #x60',
        //                                                              \       /      b      f      n      r      t      u
        'ESCAPABLE       ::= "=" | "|" | "(" | ")" | "[" | "]" | "#" | #x5C | #x2F | #x62 | #x66 | #x6E | #x72 | #x74 | #x75 HEXDIG HEXDIG HEXDIG HEXDIG',
        'UNESCAPED       ::= "\t" | "\n" | "\r" | "\r\n" | #x22 | ">" | [#x0A-#x0D] | [#x20-#x21] | [#x24-#x27] | [#x2A-#x3C] | [#x3F-#x5A] | [#x5E-#x5F] | [#x61-#x7B] | [#x7D-#xFFFF]',

        // 'number          ::= "-"? ("0" | [1-9] DIGIT*) ("." [0-9]+)? EXP?',
        // 'DIGIT           ::= [0-9]',
        // 'EXP             ::= ("e" | "E") ( "-" | "+" )? ("0" | [1-9] [0-9]*)',

        // 7b 7d { }
        // #x22 ===> "
        // A,B,D ==> \n \t \r
        // #x23 ==> # character.
        // #x28 ==> (
        // #x29 ==> )
        // #x7C ==> |
        // #x5B ==> [
        // #x5D ==> ]
        // #x3D ==> =
        // 3c #x3E ==> < >
        '',
    ].join('\n');
}
